<template>
    <div>
        <v-card class="black--text" color="white" width="100%">
            <v-toolbar color="amber" height="40">
                <v-btn icon @click="close()"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-bold body-2 text-uppercase black--text">{{orderDetail.productName}} > {{conditionType}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip label color="black" text-color="amber" small v-if="orderDetail.productNature != ''" class="caption font-weight-bold text-uppercase"> 
                        {{orderDetail.productNature}}
                    </v-chip>
            </v-toolbar>
            <v-form ref="form">
                <v-card-text>
                    <v-row class="mt-0 mx-0" v-if="conditionType != 'condition'">
                            <v-col cols=12 md=4 sm=6>
                                <v-radio-group v-model="orderType" row required>
                                    <v-radio color="amber" label="FOR" value="FOR"></v-radio>
                                    <v-radio color="amber" label="EX" value="EX"></v-radio>
                                    <v-radio color="amber" label="LP" value="LP"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0">
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="oBag" outlined color="amber" label="Bags" dense hide-details required></v-text-field>
                            </v-col>
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="oilContent" outlined color="amber" label="Oil Content" dense hide-details></v-text-field>
                            </v-col>
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="oQty" outlined color="amber" label="Qty / Tons" dense hide-details required></v-text-field>
                            </v-col>
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="oRate" outlined color="amber" label="Rate / Qtl" dense hide-details required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0">
                            <v-col cols=12 md=6 sm=6 lg=6 v-if="katta.length < 1">
                                <v-select :items="['Bardana 1','Bardana 2','Bardana 3','Bardana 4']" v-model="bdType" outlined color="amber" 
                                multiple label="Select Bardana Type" dense required></v-select>
                            </v-col>
                            <v-col cols=12 md=6 sm=6 lg=6 v-if="bdType.length < 1">
                                <v-select :items="['Katta 1','Katta 2']" v-model="katta" outlined color="amber" label="Select Katta Type" multiple dense required></v-select>
                            </v-col>
                        </v-row>
                        <v-row v-if="orderType != 'FOR'" class="mx-0">
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="location" outlined color="amber" label="Location" dense hide-details required></v-text-field>
                            </v-col>
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="mandiTax" outlined color="amber" label="Mandi Tax." dense hide-details required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="orderType != 'FOR'" class="mx-0">
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="labourCharges" outlined color="amber" label="Labour Charges" dense hide-details required></v-text-field>
                            </v-col>
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="loadingCharges" outlined color="amber" label="Loading Charges" dense hide-details required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="orderType != 'FOR'" class="mx-0">
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-text-field v-model="freight" outlined color="amber" label="Freight Charges / Qtl" dense hide-details required></v-text-field>
                            </v-col>
                            <v-col cols=12 md=6 sm=6 lg=6>
                                <v-select :items="['Company','Party','Others']" v-model="bdBy" outlined color="amber" label="Bardana By" multiple dense></v-select>
                            </v-col>
                        </v-row>
                        <v-col cols=12 md=12 lg=12 sm=12 class="text-right">
                            <v-btn  color="amber" class="black--text" :loading="loading" @click="Save()">Save</v-btn>
                        </v-col>  
                </v-card-text>
            </v-form>
        </v-card>
        <span style="display:none;">{{checkAndFetch}}</span>
    </div>
  
</template>

<script>
import { SERVER_API } from '../../API'
    export default {
        created(){
            window.addEventListener('keyup', event => {
                if(event.which === 27){
                    this.close();
                }
                if(event.which === 13){
                    this.Save();
                }
            })
        },
        data(){
            return{
                loading:false,
                orderDetail:[],
                dRate:'',
                oilContent:'',
                orderType: '',
                conditionType: '',
                oQty:'',
                oRate:'',
                bdType:[],
                katta:[],
                location:'',
                mandiTax:'',
                labourCharges:'',
                loadingCharges:'',
                freight:'',
                bdBy:[],
                oBag:''
            }
        },
        props:{
            updateid: {
                type: Number,
                required: true,
            },
            edit: {
                type: Boolean,
            },
            cond: {
                type: String,
                required: true,
            },
        },
        computed:{
            checkAndFetch(){
               return this.fetchedbyid();
            }
        },
        methods:{
            reset() {
                //this.orderType = '';
                //this.conditionType = '';
                this.oilContent = '';
                this.oQty = '';
                this.oRate = '';
                this.bdType = [];
                this.katta = [];
                this.location = '';
                this.mandiTax = '';
                this.labourCharges = '';
                this.loadingCharges = '';
                this.Freight = '';
                this.bdBy = [];
            },
            close(){
                this.reset();
                this.$emit('close',false);
            },
            async fetchedbyid(){
                this.conditionType = this.cond;
                this.orderType =  'FOR';
                const Response = await this.$http.get(SERVER_API+'/dailyupdate/byid/'+this.updateid);
                this.orderDetail = Response.data.data;
                this.dRate = this.cond == 'condition' ? this.orderDetail.conditionRate : this.orderDetail.nonConditionRate;
                

            },
            async Save(){
                try{
                    this.loading = true;
                    const Response = await this.$http.post(SERVER_API+'/order/create',{
                        updateId:this.updateid,
                        dRate:this.dRate,
                        orderType: this.orderType,
                        conditionType: this.conditionType,
                        oilContent: this.oilContent,
                        oQty: this.oQty,
                        oRate: this.oRate,
                        bdType: this.bdType,
                        katta:this.katta,
                        location:this.location,
                        mandiTax:this.mandiTax,
                        product: this.orderDetail.productId,
                        labourCharges: this.labourCharges,
                        loadingCharges: this.loadingCharges,
                        freight: this.freight,
                        bdBy: this.bdBy,
                        oBag: this.oBag

                    });
                    this.loading = false;
                    this.reset();
                    this.$emit('Response', Response.data);
                }catch(error){
                    this.loading = false;
                    this.$emit('Response', error);
                }
            }
        }
    }
</script>
<style scoped>
.fixedBar{
    z-index: 99;
    height: 64px;
    position: fixed;
    width: 100%;
}
.mt-10{
    margin-top:80px !important;
}
</style>